import React, { useState } from 'react'

import type { Meta } from '../../generated/frontend'
import type { ToastContext } from '../reviews/product-listing/ReviewsTemplateContext'
import { ArticleTemplateContext } from './ArticleTemplateContext'

export const ArticleTemplateProvider: React.FC<ArticleTemplateProviderProps> = ({
  meta,
  initialSavedStatus,
  children,
}) => {
  // Saved Status state
  const [savedStatus, setSavedStatus] = useState(initialSavedStatus)

  // Toast notification state
  const [toast, setToast] = useState<ToastContext>({
    displayToast: false,
    error: false,
    mainText: '',
    linkText: '',
    linkUrl: '',
    onClick: () => {},
  })

  return (
    <ArticleTemplateContext.Provider
      value={{
        meta,
        savedStatus,
        setSavedStatus,
        toast,
        setToast,
      }}
    >
      {children}
    </ArticleTemplateContext.Provider>
  )
}

type ArticleTemplateProviderProps = {
  meta: Meta
  initialSavedStatus: {
    isSaved: boolean
    id: string | null | undefined
  }
  children: React.ReactNode
}
